module.exports = __webpack_public_path__ + "img/Teutonia_Zirkel_transparent_white.91f74078.png";